import React, { memo } from 'react'
import { Text, View } from 'react-native'
import { Spacer } from '../../../../ui/atoms'
import { ListItem } from '../../../../ui/atoms/builder-2.0/ListItem'
import SModal from '../../../../ui/molecules/SModal'
import { GetIcon } from '../../../../ui/atoms/GetIcon'
import { IconCloseCross } from '../../../../assets/icons'
import { ECommerceRedirectionLabel } from './ECommerceRedirectionLabel'

interface PaymentStatusModalProps {
  headerIcon: React.ReactNode
  footer: React.ReactNode
  backgroundColor: string
  title: string
  subtitle: string
  paymentMethodSubtitle?: string
  paymentMethodName?: string
  paymentMethodIcon?: React.ReactNode
  modalStyle?: any
  onClose: () => void
}

export const PaymentStatusModal: React.FC<PaymentStatusModalProps> = memo(
  ({
    headerIcon,
    footer,
    backgroundColor,
    title,
    subtitle,
    paymentMethodSubtitle,
    paymentMethodName,
    paymentMethodIcon,
    modalStyle = {},
    onClose,
  }) => {
    return (
      <SModal
        visible={true}
        modalStyle={{ justifyContent: 'flex-end', ...modalStyle }}
        onClose={onClose}
        contentStyle={{ padding: 0 }}
        containerStyle={{
          backgroundColor,
          width: 355,
          borderRadius: 20,
          marginHorizontal: 10,
          padding: 0,
          // paddingTop: 30,
          display: 'flex',
          justifyContent: 'flex-start',
        }}
        testID={'payment-status-modal'}
      >
        <View
          style={{ height: 40, alignItems: 'flex-end', padding: 15 }}
          testID={'payment-status-icon'}
        >
          <GetIcon
            icon={<IconCloseCross height="14" width="14" />}
            onPress={onClose}
          />
        </View>
        <>
          {headerIcon}
          <Spacer height={16} />
          <View style={{ alignItems: 'center' }}>
            <Text
              testID={'payment-status-title'}
              style={{
                textAlign: 'center',
                fontSize: 18,
                fontWeight: '600',
                color: '#003353',
              }}
              // eslint-disable-next-line i18next/no-literal-string
            >
              {title}
            </Text>
            <Spacer height={12} />
            <Text
              style={{
                fontFamily: 'Inter, sans-serif',
                textAlign: 'center',
                marginHorizontal: 30,
                paddingBottom: 45,
                fontSize: 14,
                lineHeight: 21,
                color: '#001929',
              }}
              testID={'payment-status-subtitle'}
            >
              {subtitle}
            </Text>
            <ECommerceRedirectionLabel onRedirect={onClose} />
          </View>
          {!!paymentMethodName && (
            <View
              style={{
                backgroundColor: 'white',
                borderBottomLeftRadius: 20,
                borderBottomRightRadius: 20,
                paddingTop: 32,
                paddingHorizontal: 20,
              }}
              testID={'payment-method-info'}
            >
              <ListItem
                key={0}
                icon={paymentMethodIcon}
                title={paymentMethodName}
                subtitle={paymentMethodSubtitle}
                endIcon={<></>}
                testID={'payment-method-item'}
              />
              <Spacer height={20} />
              {footer}
            </View>
          )}
        </>
      </SModal>
    )
  },
)
